import { DialogTitle, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'
import React, { ReactElement, useId } from 'react'
import PopoverCloseButton from 'ui/components/PopoverCloseButton/PopoverCloseButton'

type CustomDialogTitleProps = {
  title: string | ReactElement
  infoText?: string | React.ReactNode
  style?: React.CSSProperties
  paddingBottom?: string
  handleClose: () => void
}

export default function CustomDialogTitle({
  title,
  handleClose,
  infoText: infoText,
  style,
  paddingBottom = '14px',
}: CustomDialogTitleProps): ReactElement {
  const uniqueId = useId()

  return (
    <DialogTitle
      id={`form-dialog-title-${uniqueId}`}
      sx={{
        paddingBottom: paddingBottom,
      }}
    >
      <Grid container alignItems="flex-start" justifyContent="space-between" direction="row" style={style}>
        <Typography variant="h2" style={{ fontWeight: 'bold' }} display="inline" alignSelf="center">
          {title}
        </Typography>
        <Typography variant="h3" alignSelf="center">
          {infoText}
        </Typography>
        <PopoverCloseButton handleClose={handleClose} />
      </Grid>
    </DialogTitle>
  )
}
